import { createSelector } from 'reselect';
import { dataSelector } from 'selectors/page/headerFooterTemplate/data/dataSelector';
import localeUtils from 'utils/LanguageLocale';

const smsBenefitSelector = createSelector(dataSelector, data => {
    if (!data) {
        return null;
    }

    const locale = localeUtils.getCurrentLanguageLocale();

    // If the data contains per-locale buckets (e.g. data['en-US']) prefer that
    if (data[locale] && data[locale].smsBenefit) {
        return data[locale].smsBenefit;
    }

    const sms = data.smsBenefit;

    // If smsBenefit is an array, try to find an item that matches the current locale
    if (Array.isArray(sms) && sms.length) {
        const match = sms.find(item => item && (item.locale === locale || (item.sys && item.sys.locale === locale)));

        return match || sms[0] || null;
    }

    return sms || null;
});

export { smsBenefitSelector };
